<button [disabled]="disabled" [class.has-text]="!!text" [attr.aria-label]="ariaLabel">
  @if (icon && !showArrow) {
    <icon [name]="icon" class="optional-icon"></icon>
  }
  @if (text) {
    <div class="text">{{text}}</div>
  }
  @if (showArrow) {
    <icon name="arrow_right" class="arrow-icon"></icon>
  }
</button>